<div class="dialog-alert">
    <div class="modal-body">
        <span>{{ message }}</span>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn" (click)="dialogRef.close()" translate>general.ok</button>
    </div>
</div>
